import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import { Link } from "react-router-dom";
import Breadcrumbs from "../../../../common-elements/breadcrumbs/Breadcrumbs";
 import DataTable from "react-data-table-component";

import { RecieptListColumn } from "./RecieptTableList";
import { tableHeaderStyles } from "../../../../styles/ReactSelectStyles";
import { RecieptData } from "../../../../data/bills-payment/reciept/RecieptData";
import SearchBar from "../../../../common-elements/search-bar/SearchBar";


function RecieptListSection() {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState("");
  return (
    <div>
      <Breadcrumbs mainTitle={t("Receipt")} parent={t("BillsPayment")} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <div className="list-product-header">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Search bar (left) */}
                    <SearchBar
                      label={t("Search")}
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      placeholder={t("SearchByLeaveName")}
                    />
                    <div className="search-dropdown"></div>
                    
                    
                  </div>
                </div>

                <div className="list-product">
                  <div className="table-responsive">
                    <DataTable
                      data={RecieptData}
                      columns={RecieptListColumn(t)}
                      customStyles={tableHeaderStyles}
                      striped
                      highlightOnHover
                      pagination
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
    
  );
}

export default RecieptListSection;
